import GenericAttachment from './GenericAttachment';

export default GenericAttachment;
